(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDeleteController',TabDeviceReleasesDeleteController);

    TabDeviceReleasesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDeviceReleases'];

    function TabDeviceReleasesDeleteController($uibModalInstance, entity, TabDeviceReleases) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDeviceReleases.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
